module.exports = __webpack_public_path__ + "static/media/11_after.1a27a12c.jpg";